import React from "react";
import IconTitleButton from "components/buttons/IconTitleButton";
import {Divider} from "@material-ui/core";

export default function TitleAddHeader(props) {
    return (
        <table className="horizontalFullScreen">
            <tbody>
            <tr className="fullWidth">
                <td style={{width: "2vw"}}>
                    <Divider/>
                </td>
                <td style={{whiteSpace: "nowrap"}}>
                    <IconTitleButton
                        icon={!(props.hideicon === "true") ?
                            <img
                                className="smallIcon"
                                style={{marginTop: "0.5em", marginLeft: "0.7em"}}
                                src={props.icon} alt=""/> : <></>
                        }
                        title={props.title}
                        onClick={() => {
                            if (props.onIconClick) {
                                props.onIconClick()
                            }
                        }}/>
                </td>
                <td style={{width: "100vw"}}>
                    <Divider/>
                </td>
            </tr>
            </tbody>
        </table>
    )
}